// src/components/ui/dashboard/achievements-card.tsx
"use client"

import { Star, Rocket, Brain, Globe, Flame, BookOpen, Calculator, Palette } from "lucide-react"
import { AchievementBadge } from "../achievement-badge"
import { useThemeStore } from "@/hooks/stores/themeStore"

export function AchievementsGrid() {
  const currentTheme = useThemeStore((state) => state.getCurrentTheme());

  const achievements = [
    {
      icon: Star,
      isUnlocked: true,
      name: "Fast Learner",
      description: "Complete 10 lessons in one day",
      color: currentTheme.colors.primary
    },
    {
      icon: Rocket,
      isUnlocked: false,
      name: "Rocket Start",
      description: "Achieve 7-day streak",
      color: currentTheme.colors.secondary
    },
    {
      icon: Brain,
      isUnlocked: true,
      name: "Mastermind",
      description: "Score 100% on 5 quizzes",
      color: currentTheme.colors.accent
    },
    {
      icon: Globe,
      isUnlocked: false,
      name: "World Explorer",
      description: "Complete 50 geography lessons",
      color: currentTheme.colors.primary
    },
    {
      icon: Flame,
      isUnlocked: true,
      name: "On Fire",
      description: "30-day streak",
      color: '#EF4444'
    },
    {
      icon: BookOpen,
      isUnlocked: true,
      name: "Bookworm",
      description: "Read 100 pages",
      color: currentTheme.colors.secondary
    },
    {
      icon: Calculator,
      isUnlocked: false,
      name: "Math Wizard",
      description: "Solve 500 math problems",
      color: currentTheme.colors.primary
    },
    {
      icon: Palette,
      isUnlocked: false,
      name: "Creative Genius",
      description: "Complete 20 art projects",
      color: currentTheme.colors.accent
    },
  ]

  return (
    <div
      className="p-6 rounded-2xl"
      style={{
        backgroundColor: 'var(--theme-card)',
        border: `1px solid ${currentTheme.colors.border}`
      }}
    >
      <div className="flex justify-between items-center mb-4">
        <h3
          className="text-xl font-bold"
          style={{ color: 'var(--theme-foreground)' }}
        >
          Achievements
        </h3>
        <p
          className="text-sm"
          style={{ color: currentTheme.colors.primary }}
        >
          {achievements.filter(a => a.isUnlocked).length}/{achievements.length} Unlocked
        </p>
      </div>
      <div className="grid grid-cols-4 gap-4">
        {achievements.map((achievement, index) => (
          <AchievementBadge
            key={index}
            {...achievement}
            themeColors={currentTheme.colors}
          />
        ))}
      </div>
    </div>
  )
}